import React, { useEffect, useState, useMemo } from "react";
import { Button, Card, Col, Table, Form, Row } from "react-bootstrap";
import Searchable from "react-searchable-dropdown";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Header from "../Header";
import { useNavigate, useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";
import ModelEditDate from "./ModelEditDate";
import ModelEditDayTour from "./ModelEditDayTour";

import {
  GetAllTourTitles,
  EditPrivateTour,
  GetAllOffers,
  DeleteLastDayTour,
  resetOffers,
} from "../../Redux/offerReducer/offerSlice";
import {
  GetAllReservations,
  resetReservations,
} from "../../Redux/reserveReducer/reserveSlice";

import {
  GetAllDayTours,
  GetAllAccommodations,
} from "../../Redux/TourOperatorReducer/TourOperatorSlice";

//============(Create Tour Page)
function EditOffer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();
  const { id } = useParams();
  const formatPrice = (price) => Math.floor(price);

  const [showEdit, setShowEdit] = useState(false);
  const [showEditDay, setShowEditDay] = useState(false);
  const [dataD, setDataD] = useState(false);

  const { destination } = useSelector((state) => state.destination);
  const { all_offers, tour_titles, isOffersSuccess, isTourTitlesSuccess } =
    useSelector((state) => state.offer);
  const { all_reservations, isReservationsSuccess } = useSelector(
    (state) => state.reservation
  );
  const { day_tours, accommodations, isHotelSuccess, isTourSuccess } =
    useSelector((state) => state.TourOperator);

  const filteredOffer = useMemo(() => {
    if (location.pathname === `/edit-reserved-offer/${id}`) {
      if (all_reservations.length === 0) return null;
      return all_reservations.find((offer) => offer.id == id);
    } else {
      if (all_offers.length === 0) return null;
      return all_offers.find((offer) => offer.id == id);
    }
  }, [all_offers, id, all_reservations]);

  const [singleOffer, setSingleOffer] = useState(filteredOffer);

  const dropdownTourTitles = useMemo(() => {
    if (!tour_titles) {
      return [];
    }
    return tour_titles.map((item) => ({
      value: item.id,
      label: item.title_en,
    }));
  }, [tour_titles]);

  // Dropdown Transportation Types
  const dropdownTransportationTypes = useMemo(() => {
    if (!destination) {
      return [];
    }
    return destination?.transportation_prices.map((item) => ({
      value: item.id,
      label: item?.transportation_type?.type,
    }));
  }, [destination]);

  const handleTourNameChange = (value) => {
    setSingleOffer((prevOffer) => ({
      ...prevOffer, // Keep other properties unchanged
      tour_name: value, // Update only tour_name
    }));
  };

  const handleTourTitleSelect = (value) => {
    setSingleOffer((prevOffer) => ({
      ...prevOffer, // Keep other properties unchanged
      tour_title_id: value, // Update only tour_name
    }));
  };

  //handleChange_transportation_type_dropdown
  const transportationTypetChange = (select) => {
    const selectedPrice = destination?.transportation_prices.find((item) => {
      return item.id === select;
    });
    // console.log(selectedPrice);
    const totalPrice =
      selectedPrice.price * filteredOffer.number_of_days +
      filteredOffer.hotels_price +
      filteredOffer.tourguide_price +
      filteredOffer.profit_price;
    setSingleOffer((prevOffer) => ({
      ...prevOffer, // Keep other properties unchanged
      transportation_id: select,
      transportation_price: selectedPrice.price * filteredOffer.number_of_days,
      total_price: totalPrice,
    }));
  };

  //handleChange_transportation_type_dropdown
  const profitPricetChange = (value) => {
    const totalPrice =
      filteredOffer.transportation_price +
      filteredOffer.hotels_price +
      filteredOffer.tourguide_price +
      formatPrice(value);
    setSingleOffer((prevOffer) => ({
      ...prevOffer, // Keep other properties unchanged
      profit_price: formatPrice(value),
      total_price: totalPrice,
    }));
  };

  useEffect(() => {
    if (!isTourTitlesSuccess) {
      dispatch(GetAllTourTitles());
    }
  }, [dispatch, isTourTitlesSuccess]);

  useEffect(() => {
    if (location.pathname === `/edit-reserved-offer/${id}`) {
      if (!isReservationsSuccess && destination) {
        dispatch(GetAllReservations(destination.id));
      }
    } else {
      if (!isOffersSuccess && destination) {
        dispatch(GetAllOffers(destination.id));
      }
    }
  }, [dispatch, destination, isOffersSuccess, isReservationsSuccess]);

  useEffect(() => {
    setSingleOffer(filteredOffer);
  }, [filteredOffer]);

  useEffect(() => {
    if (!isHotelSuccess && destination) {
      dispatch(GetAllAccommodations(destination.id));
    }
  }, [dispatch, isHotelSuccess, destination]);

  useEffect(() => {
    if (!isTourSuccess && destination) {
      dispatch(GetAllDayTours(destination?.id));
    }
  }, [dispatch, isTourSuccess, destination]);

  const handleDeleteLastRow = () => {
    if (singleOffer.private_tour_details.length > 1) {
      const lastRowId =
        singleOffer.private_tour_details[
          singleOffer.private_tour_details.length - 1
        ].id; // Get the ID of the last row
      Swal.fire({
        title: "Are you sure?",
        text: "Your will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6259ca",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            "Deleted!",
            "Your imaginary file has been deleted.",
            "success"
          );
          // console.log("Last Row ID:", lastRowId);
          dispatch(DeleteLastDayTour(lastRowId));
          if (filteredOffer.reserved == 1) {
            dispatch(resetReservations());
          } else if (filteredOffer.reserved == 0) {
            dispatch(resetOffers());
          }
        }
      });
    }
  };

  const submitData = () => {
    const data = {
      id: id,
      data: singleOffer,
    };

    // console.log(data);
    dispatch(EditPrivateTour(data));
    if (filteredOffer.reserved == 1) {
      dispatch(resetReservations());
    } else if (filteredOffer.reserved == 0) {
      dispatch(resetOffers());
    }
  };
  const handelClose = () => {
    setShowEdit(false);
  };

  const handelCloseDayModel = () => {
    setShowEditDay(false);
  };

  const handleEditDate = (id, index) => {
    const day_tour_details = filteredOffer?.private_tour_details.find(
      (tour) => tour.id == id
    );

    const data = {
      index: index,
      data: day_tour_details,
    };
    setDataD(data);
    setShowEditDay(true);
  };

  const addNewDay = () => {
    if (singleOffer?.private_tour_details?.length > 0) {
      // Get the last tour detail
      const lastTourDetail =
        singleOffer.private_tour_details[
          singleOffer.private_tour_details.length - 1
        ];

      // Extract the last date and convert it to a Date object
      const lastDate = new Date(lastTourDetail.date);

      // Add one day to the last date
      const newDate = new Date(lastDate);
      newDate.setDate(lastDate.getDate() + 1);

      // Format the new date as needed (e.g., "YYYY-MM-DD")
      const formattedNewDate = newDate.toISOString().split("T")[0];

      // Create a new tour detail
      const newTourDetail = {
        ...lastTourDetail,
        id: null, // Set a unique ID for the new day if needed
        city_id: null,
        day_tour_id: null,
        with_accommodation: null,
        accommodation_id: null,
        tourguide: null,
        number_of_rooms: 0,
        number_of_days: singleOffer.private_tour_details.length + 1,

        r_room_categories: [],

        date: formattedNewDate, // Update with the new date
      };

      // console.log(newTourDetail);
      const data = {
        index: singleOffer.private_tour_details.length + 1,
        data: newTourDetail,
      };
      // Set the updated data in dataD
      setDataD(data);

      // Trigger the edit modal
      setShowEditDay(true);
    } else {
      console.error("No tour details found to add a new day.");
    }
  };

  //(RETURN)===============================================================
  return (
    <>
      {dropdownTourTitles.length > 0 &&
      singleOffer &&
      Array.isArray(singleOffer?.private_tour_details) &&
      dropdownTransportationTypes.length > 0 ? (
        <>
          <div className="pos-relative">
            {/* <ToastContainer /> */}
            {/* <!-- Page Header --> */}
            <Header
              title={"Edit Tour"}
              subTitle1={
                destination?.name_en || "please Choose the Destination"
              }
              subTitle2={singleOffer.tour_name || "Tour Name"}
            >
              <Button
                variant="primary"
                type="button"
                className="btn my-2 btn-icon-text"
                onClick={() =>
                  navigate(
                    location.pathname === `/edit-reserved-offer/${id}`
                      ? `/reservation-view/${id}`
                      : `/all-offers/`
                  )
                }
              >
                <i className="fas fa-arrow-left me-2"></i> Back
              </Button>
            </Header>
          </div>
          {/* <!-- Row Name - Tout_Title - Package_title - Transportation_type  --> */}
          <Row className="row-sm z-index-200">
            <Col lg={12} md={12}>
              <Card className=" custom-card ">
                <Card.Body>
                  <Row className="row-sm ">
                    <Col md={12} lg={12} xl={12}>
                      <Row className="p-1 m-0  align-items-center">
                        <Col md={3} lg={3} xl={3} className="p-1">
                          <label className="">Tour Name :</label>
                          <Form.Group className=" mb-3">
                            <Form.Control
                              type="text"
                              placeholder=""
                              value={singleOffer.tour_name || ""}
                              onChange={(e) =>
                                handleTourNameChange(e.target.value)
                              }
                            />
                          </Form.Group>
                        </Col>

                        <Col md={3} lg={3} xl={3} className="p-1">
                          <label className="">Tour Title :</label>
                          <Form.Group className="form-group select2-md mb-3">
                            <Searchable
                              className="form-control select2"
                              value={singleOffer.tour_title_id}
                              placeholder={""}
                              notFoundText="No result found"
                              noInput
                              options={dropdownTourTitles}
                              onSelect={(selectedOption) =>
                                handleTourTitleSelect(selectedOption)
                              }
                              listMaxHeight={170}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3} lg={3} xl={3} className="p-1">
                          <label className="">Package Title :</label>
                          <Form.Group className=" mb-3">
                            <Form.Control
                              type="text"
                              placeholder={" "}
                              value={
                                singleOffer?.package?.package_title?.title_en ||
                                "Package Title"
                              }
                              readOnly={true}
                              // onChange={(e) => {}}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3} lg={3} xl={3} className="p-1">
                          <label className="">Transportation Type :</label>
                          <Form.Group className="form-group select2-md mb-3 ">
                            <Searchable
                              className="form-control select2"
                              value={singleOffer.transportation_id}
                              placeholder={"Choose Destination"}
                              notFoundText="No result found" // by default "No result found"
                              noInput
                              options={dropdownTransportationTypes}
                              onSelect={transportationTypetChange}
                              listMaxHeight={170} //by default 140
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="p-1 m-0  align-items-center "></Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* <!-- Row --> */}
          <Row className="row row-sm">
            <Col lg={12}>
              <Card className="custom-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: From and Till Dates */}
                    <div>
                      <span className="bg-success p-1 rounded me-1">
                        {singleOffer?.from || "N/A"}
                      </span>
                      <span className="bg-success p-1 rounded me-1">
                        {singleOffer?.till || "N/A"}
                      </span>
                    </div>
                    {/* Right: Change Date Button */}
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        setShowEdit(true);
                      }}
                    >
                      Change Date
                    </Button>
                  </div>
                  <div
                    className="table-responsive border border-bottom-0"
                    responsive="true"
                  >
                    <Table className="table  text-nowrap text-md-nowrap table-striped mg-b-0">
                      <thead>
                        <tr>
                          <th className="wd-0p">ID</th>
                          <th className="wd-0p">City</th>
                          <th className="wd-0p">Tour</th>
                          <th className="wd-0p">Accommodation</th>
                          <th className="wd-0p">Rooms Category</th>
                          <th className="wd-80p">Tourguide</th>
                          <th className="wd-0p">Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {singleOffer?.private_tour_details?.map(
                          (item, index) => (
                            <tr key={index} data-index={index}>
                              <th scope="row">
                                <div className="d-flex align-items-center ">
                                  <span className="bg-success p-1 rounded me-1">
                                    {index + 1}
                                  </span>
                                  <span className="bg-primary p-1 rounded me-2 text-nowrap">
                                    {item?.date || "Loading..."}
                                  </span>
                                </div>
                              </th>
                              <td>{item.city.city_en}</td>
                              <td>{item.day_tour.title_en} </td>
                              <td>{item.accommodation?.name || ""} </td>
                              <td>
                                {item.r_room_categories &&
                                item.r_room_categories.length > 0
                                  ? item.r_room_categories.map(
                                      (category, idx) => (
                                        <div key={idx} className="m-1">
                                          <span className="badge bg-info me-1">
                                            {category
                                              ?.accommodation_rooms_category
                                              ?.room_category?.category || ""}
                                          </span>

                                          {category.extra_bed == 1 ? (
                                            <>
                                              <span className="badge bg-success me-1">
                                                Extra bed
                                              </span>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      )
                                    )
                                  : ""}
                              </td>
                              <td>
                                {item.tourguide == 1 && (
                                  <>
                                    <span className="badge bg-success me-1">
                                      Tourguide
                                    </span>
                                  </>
                                )}
                              </td>
                              <td>
                                {item?.email_send !== 1 && (
                                  <>
                                    <Link
                                      to={`#`}
                                      className="btn btn-sm btn-info me-1"
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevent default link behavior
                                        handleEditDate(item.id, index + 1); // Pass the item.id to the function
                                      }}
                                    >
                                      <i className="fe fe-edit-2"></i>
                                    </Link>
                                  </>
                                )}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      variant="danger"
                      size="sm"
                      className="me-2"
                      onClick={handleDeleteLastRow}
                    >
                      Remove Day
                    </Button>
                    <Button variant="success" size="sm" onClick={addNewDay}>
                      Add Day
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* <!-- End Row --> */}
          {/* <!-- Row Prices --> */}
          <Row className="row-sm">
            <Col lg={12} md={12}>
              <Card className=" custom-card">
                <Card.Body>
                  <Row className="row-sm">
                    <Col md={12} lg={12} xl={12}>
                      <Row className="p-1 m-0  align-items-center">
                        <Col md={2} className="p-1">
                          <label className="">Transportation P :</label>
                          <Form.Group className=" ">
                            <Form.Control
                              value={singleOffer.transportation_price}
                              type="text"
                              placeholder=" "
                              readOnly={true}
                              onChange={(e) => {}}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2} className="p-1">
                          <label className="">Tourguide P :</label>
                          <Form.Group className=" ">
                            <Form.Control
                              value={singleOffer.tourguide_price}
                              type="text"
                              placeholder=" "
                              readOnly={true}
                              onChange={(e) => {}}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2} className="p-1">
                          <label className="">Hotels P :</label>
                          <Form.Group className=" ">
                            <Form.Control
                              value={singleOffer.hotels_price}
                              type="text"
                              placeholder=" "
                              readOnly={true}
                              onChange={(e) => {}}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2} className="p-1">
                          <label className="">Profit P :</label>
                          <Form.Group className=" ">
                            <Form.Control
                              value={singleOffer.profit_price}
                              type="number"
                              placeholder=" "
                              onChange={(e) => {
                                profitPricetChange(e.target.value);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} className="p-1">
                          <label className="">Total P :</label>
                          <Form.Group className=" ">
                            <Form.Control
                              value={singleOffer.total_price}
                              type="text"
                              placeholder=" "
                              onChange={(e) => {}}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* <!-- End Row --> */}
          {/* <!-- Row Submit--> */}
          <Row className="row-sm">
            <Col lg={12} md={12}>
              <Card className=" custom-card">
                <Card.Body>
                  <Row className="row-sm">
                    <Col md={12} lg={12} xl={12}>
                      <div className="">
                        <Button
                          className="btn ripple btn-main-primary btn-block"
                          onClick={submitData}
                        >
                          Save
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* <!-- End Row --> */}
          {singleOffer !== null && (
            <>
              <ModelEditDate
                itemData={singleOffer}
                show={showEdit}
                handelClose={handelClose}
                reserved={filteredOffer.reserved}
              />
              {showEditDay && (
                <>
                  <ModelEditDayTour
                    Data={dataD}
                    show={showEditDay}
                    handelClose={handelCloseDayModel}
                    destination={destination}
                    day_tours={day_tours}
                    reserved={filteredOffer.reserved}
                    accommodations={accommodations}
                  />
                </>
              )}
            </>
          )}
        </>
      ) : (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(EditOffer);
